export default __webpack_public_path__ + "umr.ed1bfc4.jpeg";